export default __webpack_public_path__ + "static/media/doctor.e2df3008.png";